import { rewriteUrl as rewriteHelpCenterUrl } from '@/utils/helpCenterUrlRewriter'
import { type LinkProps, Link as MarketistLink } from '@/components/Link/Link'

function Link({ children, ...props }: LinkProps) {
    return (
        <MarketistLink
            style={{
                '--marketist-link-decoration': 'none',
                '--internal-link-hover-decoration': 'underline',
            }}
            size="inherit"
            href={rewriteHelpCenterUrl(props.href || '')}
            {...props}
        >
            {children}
        </MarketistLink>
    )
}

export { Link }
